import api from './api';

export const getVideoServers = () => api.get('/api/v1/video-servers');
export const getServerRoute = ({ path, serverId }) =>
  api.get(`/api/v1/video-servers/route?path=${path}&serverId=${serverId}`);
export const createFolder = ({ folderPath, serverId, folder }) =>
  api.post('/api/v1/video-servers/folder', { folderPath, serverId, folder });
export const deleteFolder = ({ serverId, folderpath }) =>
  api.delete(`/api/v1/video-servers/folder?serverId=${serverId}&folderpath=${folderpath}`);
export const deleteVideo = ({ serverId, filename, filepath }) =>
  api.delete(`/api/v1/video-servers/video?serverId=${serverId}&filename=${filename}&filepath=${filepath}`);
export const signUpload = (serverId) => api.get(`/api/v1/video-servers/sign-upload/${serverId}`);
export const lookupVideoAssignment = (url) =>
  api.get(`/api/v1/video-servers/lookup?url=${encodeURIComponent(url)}`);
